import { useContext } from 'react';
import { CommentEditorContext, EditorContext } from '../context';
import { useIsCommentEditorEmpty } from './useIsCommentEditorEmpty';
/**
 * Returns `true` if the editor contains valid text that we can submit, regardless of if the user is
 * using the full featured editor or the fallback editor.
 */ export function useIsCommentEditorSubmittable() {
    const isEmpty = useIsCommentEditorEmpty();
    const { isBusy , submitValidator  } = useContext(CommentEditorContext);
    const { state: editorState  } = useContext(EditorContext);
    if (submitValidator && editorState) {
        return submitValidator(editorState);
    }
    return !isEmpty && !isBusy;
}
